import  * as React from "react";
import { AppCtxProvider } from "./app_context";
import { TProviderProps, TProviderState } from "./types";


export default class AppProvider extends React.Component<TProviderProps,TProviderState>{
    // state = {
    //     scene: {}
    //     }
   
  

    constructor(props){
      super(props);
      //this.state = this.state;
    }

    render() {
        return (
            <AppCtxProvider value={this.props.context} >
                {this.props.children}
            </AppCtxProvider>
        );
    }
};